import { createSlice } from "@reduxjs/toolkit"

const bookingSlice = createSlice({
  name: "booking",
  initialState: { bookingData: null },
  reducers: {
    setBookingData: (state, { payload }) => {
      state.bookingData = payload
    },
    clearBookingData: (state) => {
      state.bookingData = null
    },
  },
})

export const { setBookingData, clearBookingData } = bookingSlice.actions

export default bookingSlice
